// Meta Pixel (Facebook/Instagram) Implementation
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}

export const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID;

export const initMetaPixel = () => {
  if (typeof window !== 'undefined' && META_PIXEL_ID) {
    console.log('[Meta Pixel] Initializing Facebook Pixel:', META_PIXEL_ID);
    !(function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );

    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  } else if (typeof window !== 'undefined') {
    console.log('[Meta Pixel] Not initialized - VITE_META_PIXEL_ID not set');
  }
};

export const trackMetaEvent = (eventName: string, params?: Record<string, any>) => {
  console.log('[Meta Pixel] Event:', eventName, params);
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

export const trackMetaCustomEvent = (eventName: string, params?: Record<string, any>) => {
  console.log('[Meta Pixel] Custom Event:', eventName, params);
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

// Specific conversion tracking functions for your business
export const trackSignup = (method?: string) => {
  trackMetaEvent('CompleteRegistration', {
    content_name: 'User Registration',
    content_category: 'signup',
    method: method || 'email'
  });
};

export const trackSubscription = (tierName: string, value?: number, currency: string = 'USD') => {
  trackMetaEvent('Subscribe', {
    content_name: `${tierName} Subscription`,
    content_category: 'subscription',
    value: value,
    currency: currency,
    predicted_ltv: value ? value * 12 : undefined // Estimate annual value
  });
};

export const trackPurchase = (value: number, currency: string = 'USD', contentType: string = 'subscription') => {
  trackMetaEvent('Purchase', {
    value: value,
    currency: currency,
    content_type: contentType,
    content_name: 'Quixocial Subscription'
  });
};

export const trackTierUpgrade = (fromTier: string, toTier: string, value?: number) => {
  trackMetaCustomEvent('TierUpgrade', {
    from_tier: fromTier,
    to_tier: toTier,
    content_name: `Upgrade from ${fromTier} to ${toTier}`,
    value: value,
    currency: 'USD'
  });
};

export const trackTrialStart = (tierName: string) => {
  trackMetaEvent('StartTrial', {
    content_name: `${tierName} Trial`,
    content_category: 'trial',
    predicted_ltv: 50 // Estimated trial conversion value
  });
};

export const trackAddPaymentInfo = () => {
  trackMetaEvent('AddPaymentInfo', {
    content_name: 'Payment Method Added',
    content_category: 'payment'
  });
};

export const trackViewContent = (contentType: string, contentName?: string) => {
  trackMetaEvent('ViewContent', {
    content_type: contentType,
    content_name: contentName || contentType,
    content_category: 'engagement'
  });
};

export const trackLead = (leadType: string = 'contact_form') => {
  trackMetaEvent('Lead', {
    content_name: 'Lead Generation',
    content_category: leadType
  });
};

export const trackInitiateCheckout = (value?: number, currency: string = 'USD') => {
  trackMetaEvent('InitiateCheckout', {
    value: value,
    currency: currency,
    content_name: 'Subscription Checkout',
    content_category: 'checkout'
  });
};
